export function shouldAttemptDetectedLanguagePersistence({
    publicUrlAuthoritative,
    sessionLoading,
    signedIn,
    profileResolved,
    profileUserId,
    sessionUserId,
    preferredLanguageTag,
    sessionLanguageTag,
    detectedLanguageTag,
}: {
    publicUrlAuthoritative: boolean;
    sessionLoading: boolean;
    signedIn: boolean;
    profileResolved: boolean;
    profileUserId: string | null;
    sessionUserId: string | null;
    preferredLanguageTag: string | null;
    sessionLanguageTag: string | null;
    detectedLanguageTag: string | null;
}): boolean {
    return !publicUrlAuthoritative
        && !sessionLoading
        && signedIn
        && profileResolved
        && Boolean(profileUserId)
        && profileUserId === sessionUserId
        && !preferredLanguageTag
        && !sessionLanguageTag
        && Boolean(detectedLanguageTag);
}
